import { FunctionComponent } from "react";

interface IProps {
  stroke?: string;
  width?: string;
  height?: string;
}

const Cross: FunctionComponent<IProps> = ({ stroke = "#333", width = "16", height = "14" }) => (
  <svg width={width} height={height} viewBox="0 0 16 14" aria-hidden="true">
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M-2-3h20v20H-2z" />
      <path stroke={stroke} strokeLinecap="round" d="M14.667.333 1.333 13.667M1.333.333l13.334 13.334" />
    </g>
  </svg>
);

export default Cross;
